module.exports = __webpack_public_path__ + "media/images/flags/BM-cf6db0847c4c78d8370cc5bf199b49af.svg";